<template>
  <div class="single-choice-detail">
    <div v-if="optionItems.len > 0" class="radioQuestion">
      <p v-show="isError" style="color: rgb(247, 73, 69)">{{ errorText }}</p>
      <el-radio-group
        class="flex flex-wrap items-center"
        v-model="getModel(rowData).model"
        :disabled="getDisabled()"
        @input="update($event)"
      >
        <!-- change事件 无法获取 改变的值 -->
        <el-radio class="flex items-center" v-for="(item, idx) in optionItems.items" :label="item.id" :key="idx">
          <span>{{ getGroupName(item.id) ? '【' + getGroupName(item.id) + '】' : '' }}</span>
          <span
            class="flex-shrink-0"
            style="min-width: 100px; white-space: normal"
            v-html="transformHtml(item.content.richText || item.content.text)"
          ></span>
          <!-- 统一用richText 但是无法放大
            <template v-for="img in getImg(item)">
            <el-image class="w-8 h-8 flex-shrink-0" 
              :src="img"
              :z-index="5000"
              :preview-src-list="getImg(item)"/>
          </template> -->
          <!-- 其他选项 输入框 -->
          <el-input
            v-if="item.is_other_item === 1 && hadSelect(item)"
            v-model="getOtherModel(rowData, item).model"
            @input="setOtherVal($event, item)"
            @focus="onFocus($event)"
            @blur="onBlur($event, item)"
            placeholder="请填写其他选项内容"
          ></el-input>
          <!-- 选项增加选项描述提示 -->
          <template>
            <el-tooltip class="item" :content="item.tips" placement="top-start">
              <i v-show="item.tips && item.tips.length" style="color: #606266; margin: 0 5px" class="el-icon-question"></i>
            </el-tooltip>
          </template>
        </el-radio>
      </el-radio-group>
      <div class="flex items-center" style="margin-top: 5px">
        <div>
          <img-box :imgList="rowData" :xArray="updateArr" :getType="qType1"></img-box>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import imgBox from '../ImageBox.vue'
import { itemInitOptions } from '../config/config.js'
import { checkOtherVal, saveArr, getDisabled } from '../public/index.js'
import '../public/style.css'

export default {
  name: 'SingleChoiceDetail',
  components: { imgBox },
  props: {
    rowData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    // 需要更新的 数组
    updateArr: {
      type: Array,
      default: () => {
        return []
      }
    },
    // 关联选项
    appendItems: {
      type: Array,
      default: () => {
        return []
      }
    },
    allQuesionList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      qType1: 'radio',
      errorText: '',
      isError: false,
      oldInputVal: ''
      // connectItems:[]
    }
  },
  created() {
    // this.connectItems.push(...this.rowData.items.map(item=>item))
  },
  computed: {
    // 选项及其个数
    optionItems() {
      let items = this.rowData?.questionDetails?.issue?.items??[]
      if (this.appendItems.length) {
        items = [...this.appendItems, ...items]
      }
      return {
        items,
        len: items.length
      }
    },
    getModel() {
      return function (row) {
        const items = row.items || []
        // 有值 编辑
        if (Array.isArray(items) && items.length > 0) {
          return {
            model: items[0]['optionId']
          }
          // 无值 初始化
        } else {
          // 单选题
          items.push(
            Object.assign({}, itemInitOptions, {
              optionId: ''
            })
          )
          return {
            model: items[0].optionId
          }
        }
      }
    },
    getOtherModel() {
      return function (row, item) {
        const optionId = item.id // 当前选项id
        // 从 答案 中 寻找当前的值
        const answerFind = row.items.find(i => i.optionId === optionId)
        const res = (answerFind && answerFind.value) || ''
        return {
          model: res.indexOf('|') !== -1 ? res.split('|')[1] : ''
        }
      }
    },
    getGroupName() {
      return function (itemId) {
        const item_groups = this.rowData.questionDetails.issue.item_groups
        const g =
          item_groups &&
          item_groups.find(item => {
            return item.item_ids.includes(itemId)
          })
        return (g && g.title) || ''
      }
    }
  },
  inject: ['transformHtml'],
  methods: {
    // 其他选项 输入的input事件
    setOtherVal(val, item) {
      const optionId = item.id // 当前选项id
      // 从 答案 中 寻找当前的值
      const answerFind = this.rowData.items.find(i => i.optionId === optionId)
      answerFind.value = item.content.text + '|' + val
      // this.saveArr()
    },
    // 判断是否 选中选项
    hadSelect(optItem) {
      return this.rowData.items.findIndex(r => r.optionId === optItem.id) !== -1
    },
    update(val) {
      this.rowData.items[0].optionId = val
      this.rowData.items[0].value = this.optionItems.items.find(itm => {
        return itm.id === val
      }).content.text // text 不是 richText
      this.saveArr()
    },
    // 获取单选带有图片的答案
    getImg(item) {
      const answerArr = []
      if (item && item.content && item.content.image) {
        const imgs = item.content.image
        imgs.forEach(img => {
          answerArr.push(window.location.origin + '/fill/api/v1/download?fileName=' + img.url)
        })
      }
      return answerArr
    },
    // saveArr() {
    //   const existIdx = this.updateArr.findIndex((item) => {
    //     return item.questonId === this.rowData.questonId
    //   })
    //   if(existIdx === -1) { //添加
    //     this.updateArr.push(this.rowData)
    //   }
    // },
    onFocus(e) {
      this.oldInputVal = e.target.value
    },
    onBlur(e, item) {
      let res = this.checkOtherVal(e.target.value, item) // 校验
      this.isError = res
      if (res) {
        this.rowData.items.find(i => i.optionId === item.id).value = item.content.text + '|' + this.oldInputVal
      }
      this.saveArr()
    },
    // 校验
    checkOtherVal,
    saveArr,
    getDisabled
  },
  watch: {
    // optionItems(val,o){
    //   let optionIdArr = val.items.map(it=>it.id);
    //   // let cItems = this.rowData.items;
    //   let cItems= this.rowData.items.filter(itt=>optionIdArr.includes(itt.optionId));
    //   this.rowData.items = JSON.parse(JSON.stringify(cItems));
    //   // console.log(cItems);
    //   console.log(this.rowData.items);
    //   console.log(val.items)
    // this.optionItems=val;
    // console.log("--------------")
    // console.log(val)
    // console.log(o)
    // console.log("--------------")
    // console.log(this.appendItems)
    // console.log(this.rowData.items)
    // let optionIds = val.items.map(itt=>itt.id)
    // console.log(optionIds)
    // let newRes = this.rowData.items.filter(ele=>optionIds.includes(ele.optionId));
    // console.log(newRes)
    // // this.rowData.items.pop();
    // // this.rowData.items.push(newRes);
    // console.log(this.rowData)
    // }
  }
}
</script>
<style lang="scss" scoped>
.single-choice-detail {
  .radioQuestion {
    ::v-deep .el-radio__label {
      display: flex;
      align-items: center;
    }
  }
}
</style>
